import { readableMonth } from '@hotjar/webapp/lib/time';

export type NPSGraphResolution = 'daily' | 'weekly' | 'monthly';

export interface NPSResolutionChoice {
  label: string;
  value: NPSGraphResolution;
  disallowedAboveDays?: number;
  disallowedBelowDays?: number;
}

export const resolutionChoices: NPSResolutionChoice[] = [
  { label: 'resolution.daily', value: 'daily', disallowedAboveDays: 30 },
  {
    label: 'resolution.weekly',
    value: 'weekly',
    disallowedAboveDays: 365,
    disallowedBelowDays: 30,
  },
  { label: 'resolution.monthly', value: 'monthly', disallowedBelowDays: 90 },
];

export function isResolutionViable(
  resolutionChoice: NPSResolutionChoice,
  dateRangeInDays: number,
): boolean {
  if (
    resolutionChoice.disallowedAboveDays &&
    dateRangeInDays > resolutionChoice.disallowedAboveDays
  ) {
    return false;
  }
  if (
    resolutionChoice.disallowedBelowDays &&
    dateRangeInDays < resolutionChoice.disallowedBelowDays
  ) {
    return false;
  }
  return true;
}

export function getFirstViableResolution(dateRangeInDays: number): NPSResolutionChoice {
  const newResolution = resolutionChoices.find((resolutionChoice) =>
    isResolutionViable(resolutionChoice, dateRangeInDays),
  );
  return newResolution ?? resolutionChoices[0];
}

const dayInMillis = 24 * 60 * 60 * 1000;

function getReadableDayDate(date: Date, includeYear = false): string {
  const dateString = `${readableMonth(date.getMonth(), true)} ${date.getDate()}`;
  if (includeYear) {
    return `${dateString}, ${date.getFullYear()}`;
  }
  return dateString;
}

export function formatDateForResolution(
  date: Date,
  resolution: NPSGraphResolution,
  includeYear = false,
): string {
  if (resolution === 'monthly') {
    return readableMonth(date.getMonth(), false);
  }
  if (resolution === 'weekly') {
    const weekBefore = new Date(date.getTime() - 6 * dayInMillis);
    return `${getReadableDayDate(weekBefore)} - ${getReadableDayDate(date)}`;
  }
  return getReadableDayDate(date, includeYear);
}
